// extracted by mini-css-extract-plugin
module.exports = {"item":"ImagesList_item__3Pxfe","imageSquare":"ImagesList_imageSquare__2pQKq"};